export type ExceptionStage = 'format' | 'queue' | 'send' | 'flush';

function hasItemDiscount(order: any): boolean {
  return (order?.items || []).some((item: any) => Number(item?.itemDiscount) > 0);
}

function hasBillDiscount(order: any): boolean {
  const fees = order?.feesAndDiscounts;
  if (!fees || typeof fees !== 'object' || Array.isArray(fees)) return false;
  return Object.values(fees).some((item: any) => item?.type === 'discount' && Number(item?.amount) > 0);
}

export function hasDiscount(order: any): boolean {
  return hasItemDiscount(order) || hasBillDiscount(order);
}

export function scenarioNames(event: string, order?: any, trans?: any): string[] {
  const names: string[] = [];
  const modImpr = trans?.modImpr || order?.modImpr;
  if (event === 'correct_payment_step1') names.push('payment change step 1');
  else if (event === 'correct_payment_step2') names.push('payment change step 2');
  else if (event === 'refund') {
    const custom = Number(order?.mevRefundAmount) > 0;
    const selected = Array.isArray(order?.mevRefundItems) ? order.mevRefundItems.length : 0;
    const original = Array.isArray(order?.items) ? order.items.length : 0;
    names.push(custom || (original > 0 && selected > 0 && selected < original) ? 'partial refund' : 'full refund');
  } else if (event === 'cancel_after_print') names.push('cancel open addi');
  else if (event === 'cancel_before_print') names.push('abandonment');
  else if (modImpr === 'RPR' || event === 'reprint') names.push('reproduction');
  else if (modImpr === 'DUP') names.push('duplicate');
  else if (event === 'temporary' && Number(order?.printVersionSuffix) > 0) names.push('temporary bill revised');

  if (!names.includes('discount') && hasDiscount(order)) names.push('discount');
  return names;
}

export function logExceptionScenario(scenario: string, stage: ExceptionStage, trans: any): void {
  if (!scenario) return;
  console.log(`[exception scenario] [${scenario}]`, {
    stage,
    noTrans: trans?.noTrans || null,
    typTrans: trans?.typTrans || null,
    modPai: trans?.modPai || null,
    modImpr: trans?.modImpr || null,
    formImpr: trans?.formImpr || null,
    apresTax: trans?.mont?.apresTax ?? null,
    refs: Boolean(trans?.refs?.length),
  });
}

export function logExceptionScenarios(event: string, stage: ExceptionStage, trans: any, order?: any): void {
  scenarioNames(event, order, trans).forEach((scenario) => logExceptionScenario(scenario, stage, trans));
}
